import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import virtualCardService from '../../services/virtualCard.service';
import { NetworkError } from '../../state-machine/actions/genericActions';

export class EmbedUrlError extends Error {
  retriable: boolean;
  constructor(message: string, retriable: boolean) {
    super(message);
    this.retriable = retriable;
  }
}

export type GetEmbedUrlResult = {
  embedUrl: string;
  embedUrlError: EmbedUrlError | null;
  cardExpiration: number;
};

const queryEmbedUrl = async (orderId: string): Promise<GetEmbedUrlResult> => {
  try {
    const { data } = await virtualCardService.getEmbedUrlById(orderId);

    if (data?.generateEmbeddedVirtualCardRequest?.generateEmbeddedVirtualCardRequestErrors?.length) {
      return {
        embedUrl: '',
        embedUrlError: new EmbedUrlError('embed url generation failed', true),
        cardExpiration: 0,
      };
    } else {
      return {
        embedUrl: data?.generateEmbeddedVirtualCardRequest?.embeddedVirtualCardRequest,
        embedUrlError: null,
        cardExpiration: data?.generateEmbeddedVirtualCardRequest?.cardExpiration,
      };
    }
  } catch (err: any) {
    const error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        return {
          embedUrl: '',
          embedUrlError: new EmbedUrlError('could not retrieve embedUrl from AES', true),
          cardExpiration: 0,
        };
    }
    throw error;
  }
};

export default queryEmbedUrl;
